<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>

<div class="content">
  <div>
    <div
      class="ui basic vertical segment company-details"
      [ngClass]="{ loading: pending }"
    >
      <div class="tabs">
        <button
          class="tab"
          [ngClass]="{ active: activeTab === 1 }"
          (click)="changeTab(1)"
        >
          Members
        </button>
        <button
          class="tab"
          [ngClass]="{ active: activeTab === 2 }"
          (click)="changeTab(2)"
        >
          Watchers
        </button>
        <button
          class="tab"
          [ngClass]="{ active: activeTab === 3 }"
          (click)="changeTab(3)"
        >
          Company Details
        </button>
      </div>
      <div class="tab-content" id="tab-content-1" *ngIf="activeTab === 1">
        <div class="members" *ngFor="let watcher of participants">
          <div class="image">
            <img
              class="watcher-image"
              src="{{ loadImage(watcher.appUser.image) }}"
              alt="chat watcher image"
            />
          </div>
          <div class="member_list">
            <h2>
              {{
                watcher?.appUser?.firstName + " " + watcher?.appUser?.lastName
              }}
            </h2>
            <p>{{ watcher?.appUser?.appUserEmail }}</p>
            <span
              *ngIf="
                watcher?.appUser.organization.organizationLongName ||
                watcher?.appUser.organization.organizationShortName
              "
              >{{
                watcher?.appUser.organization.organizationLongName ||
                  watcher?.appUser.organization.organizationShortName
              }}</span
            >
          </div>
        </div>
        <div
          class="ui basic vertical segment"
          *ngIf="participants && participants.length < 1"
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            min-height: 200px;
          "
        >
          <div>There are no participants watching this chat</div>
        </div>
      </div>
      <div class="tab-content" id="tab-content-2" *ngIf="activeTab === 2">
        <div class="members" *ngFor="let watcher of watchers">
          <div class="image">
            <img
              class="watcher-image"
              src="{{ loadImage(watcher.image) }}"
              alt="chat watcher image"
            />
          </div>
          <div class="member_list">
            <h2>
              {{
                watcher?.appUser?.firstName + " " + watcher?.appUser?.lastName
              }}
            </h2>
            <p>{{ watcher?.appUser?.appUserEmail }}</p>
            <span
              *ngIf="
                watcher?.appUser.organization.organizationLongName ||
                watcher?.appUser.organization.organizationShortName
              "
              >{{
                watcher?.appUser.organization.organizationLongName ||
                  watcher?.appUser.organization.organizationShortName
              }}</span
            >
          </div>
        </div>
        <div
          class="ui basic vertical segment"
          *ngIf="watchers && watchers.length < 1"
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            min-height: 200px;
          "
        >
          <div>There are no participants watching this chat</div>
        </div>
      </div>
      <div
        class="tab-content namelist"
        id="tab-content-3"
        *ngIf="activeTab === 3"
      >
        <div>
          <h2 class="ui sub header">COMPANY NAME</h2>
          <span>{{
            data.organization?.organizationShortName ||
              data.publicUser?.username ||
              data.publicUser?.name ||
              "PUBLIC USER"
          }}</span>
        </div>
        <div>
          <h2 class="ui sub header">COMPANY EMAIL</h2>
          <span>{{ data?.userEmail }}</span>
        </div>
        <div>
          <h2 class="ui sub header">COMPANY PHONE NUMBER</h2>
          <span>{{
            data.organization?.phone ||
              data.organization?.phoneNumber ||
              data.publicUser?.phoneNumber ||
              data.publicUser?.phone ||
              "---"
          }}</span>
          <!-- 0907 456 7898 -->
        </div>
      </div>

      <!-- <h3 class="ui primary header">Company Details</h3>
      <div class="ui divider"></div> -->

      <!-- <div *ngIf="modal.context.title == 'View More Details'">
        <h2 class="ui sub header">NUMBER OF TOPICS</h2>
        <span>{{ assignedTopics.length }}</span>
      </div> -->
    </div>
    <!-- <div
      class="ui basic vertical segment more-details"
      *ngIf="modal.context.title == 'View More Details'"
    >
      <h3 class="ui primary header">Topics</h3>
      <div class="ui divider"></div>
      <div class="items">
        <div class="item" *ngFor="let topic of assignedTopics">
          <span>{{ topic | titlecase }}</span>
        </div>
      </div>
    </div> -->
  </div>
  <div class="actions" style="border: none">
    <button class="ui basic button" (click)="modal.deny(undefined)">
      Cancel
    </button>
  </div>
</div>
